module.exports = __webpack_public_path__ + "static/media/header.0c237152.png";